'use client';

import {debounce} from 'lodash';
import {useTranslations} from 'next-intl';
import {useCallback, useMemo, useState} from 'react';
import {Range} from '../../../../../components/design-system';
import {useFindFacetsQuery} from '../query/useFindFacetsQuery';
import FilterSection from './FilterSection';
import useFilters from './hooks/useFilters';

function FilterSectionPrice() {
  const t = useTranslations('shop');

  const {filters, set} = useFilters();

  const {data: facets, isLoading} = useFindFacetsQuery();

  const prices = useMemo(() => {
    if (!facets.prices) {
      return [];
    }
    return [...facets.prices]
      .sort((a, b) => a.price - b.price)
      .map((p, index) =>
        index === facets.prices.length - 1
          ? Math.ceil(p.price)
          : Math.floor(p.price),
      );
  }, [facets.prices]);

  const [selected, setSelected] = useState([0, 0]);

  const computedValue = useMemo(() => {
    return [
      selected[0] || filters.priceMin || 0,
      selected[1] || filters.priceMax || prices[prices.length - 1] || 0,
    ];
  }, [selected, filters.priceMin, filters.priceMax, prices]);

  const sendRequest = useCallback(([priceMin, priceMax]: number[]) => {
    set({priceMin, priceMax});
  }, [set]);

  const debouncedSendRequest = useMemo(() => {
    return debounce(sendRequest, 300);
  }, [sendRequest]);

  // @ts-ignore
  function handleChange([min, max]: number[] | undefined) {
    const value = [min || 0, max || prices[prices.length - 1]];
    setSelected(value);
    debouncedSendRequest(value);
  }

  if (isLoading) {
    return null;
  }

  return (
    <FilterSection title={t('filter.price.title')}>
      <div className="space-y-2 pt-3">
        <Range
          min={0}
          max={prices[prices.length - 1]}
          value={computedValue}
          onChange={handleChange}
        />
      </div>
    </FilterSection>
  );
}

export default FilterSectionPrice;
